module.exports = __webpack_public_path__ + "img/handraw_localisation orange.32c493df.svg";